import clsx from 'clsx';
import React from 'react';

import styles from './Spinner.module.scss';

interface SpinnerProps {
  size?: 'extraSmall' | 'small' | 'large';
  useAccentColor?: boolean;
}

export const Spinner = ({
  size = 'large',
  useAccentColor = false,
}: SpinnerProps) => (
  <div
    className={clsx(styles.spinner, styles[size], {
      [styles.accent]: useAccentColor,
    })}
    data-testid="spinner"
  />
);
